export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/t_shirts_merchandise.df9bb96.svg";